import React from 'react';
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import { useTranslation } from '../app/LanguageContext';

/**
 * Barra de filtro para listagens: apenas filtros em segmentos (toggle buttons).
 * Ordenação fica nos headers da tabela (clique na coluna).
 *
 * @param {Object} props
 * @param {string} [props.filterValue] - Valor do filtro (ex.: 'ALL', 'PRODUCT')
 * @param {Array<{value: string, labelKey: string}>} [props.filterOptions]
 * @param {function(string)} [props.onFilterChange]
 * @param {string} [props.filterLabelKey] - Chave i18n do rótulo do filtro
 */
const ListToolbar = ({
  filterValue,
  filterOptions = [],
  onFilterChange,
  filterLabelKey = 'products.item_type',
}) => {
  const { translate } = useTranslation();
  const hasFilter = filterOptions.length > 0 && onFilterChange;

  if (!hasFilter) return null;

  return (
    <Box
      component="header"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1.5,
        py: 2,
        px: 3,
        mb: 2,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'grey.50',
      }}
    >
      <Typography
        variant="overline"
        sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: 1 }}
      >
        {translate(filterLabelKey)}
      </Typography>
      <ToggleButtonGroup
        value={filterValue}
        exclusive
        onChange={(_, v) => v != null && onFilterChange(v)}
        size="small"
        sx={{
          '& .MuiToggleButtonGroup-grouped': {
            border: 1,
            borderColor: 'divider',
            px: 2,
            py: 0.75,
            '&.Mui-selected': {
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': { bgcolor: 'primary.dark' },
            },
          },
        }}
      >
        {filterOptions.map((opt) => (
          <ToggleButton key={opt.value} value={opt.value} aria-label={translate(opt.labelKey)}>
            {translate(opt.labelKey)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default ListToolbar;
